import { createFileRoute } from "@tanstack/react-router";

import { ReportsScreen } from "@/interactors/ReportsScreen";
import { headWithCustomTitle } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/reports/")({
  component: ReportsScreen,
  head: () => headWithCustomTitle("main:reports.title"),
});
